/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_TitleInputs */



/**
* | output |
* | --- |
* | "Event Group Sync" |
*
* @param {Event_Group_Sync_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_title = /** @type {((inputs?: Event_Group_Sync_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "de") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "it") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "es") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Event Group Sync")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Event Group Sync")
	return /** @type {LocalizedString} */ ("Event Group Sync")
});